
// Attendre que le DOM soit vraiment prêt
function waitForDOM() {
  return new Promise((resolve) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', resolve);
    } else {
      resolve();
    }
  });
}

// Attendre que les éléments du carousel existent
function waitForCarouselElements() {
  return new Promise((resolve) => {
    var attempts = 0;
    var maxAttempts = 50; // 50 x 100ms = 5 secondes max
    
    var checkInterval = setInterval(function() {
      attempts++;
      var nav = document.querySelector('.productView-nav');
      var slides = nav ? nav.querySelectorAll('.productView-image:not(.slick-cloned)') : [];
      var thumbs = document.querySelectorAll('.productView-thumbnail:not(.slick-cloned)');
      
      console.log('[carousel] Tentative ' + attempts + ' | nav:', !!nav, '| slides:', slides.length, '| thumbs:', thumbs.length);
      
      // Éléments trouvés ET au moins un slide ET au moins une vignette
      if (nav && slides.length > 0 && thumbs.length > 0) {
        clearInterval(checkInterval);
        console.log('[carousel] DOM prêt ! Initialisation...');
        resolve({ nav, slides, thumbs });
        return;
      }
      
      // Timeout : on abandonne après 5 secondes
      if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
        console.log('[carousel] TIMEOUT - éléments non trouvés');
        resolve(null);
      }
    }, 100);
  });
}

// Initialiser le carousel
async function initCarousel() {
  console.log('[carousel] Script démarré');
  
  // Étape 1 : attendre que le DOM de base soit prêt
  await waitForDOM();
  console.log('[carousel] DOMContentLoaded OK');
  
  // Étape 2 : attendre que les éléments du carousel existent
  var result = await waitForCarouselElements();
  
  if (!result) {
    console.log('[carousel] ERREUR : Impossible de trouver les éléments du carousel');
    return;
  }
  
  var nav = result.nav;
  var slides = Array.from(result.slides);
  var thumbs = Array.from(result.thumbs);
  
  // **CRITIQUE** : Détruire Slick s'il est initialisé
  if (nav.classList.contains('slick-initialized')) {
    try {
      if (window.jQuery && jQuery(nav).slick) {
        jQuery(nav).slick('unslick');
        console.log('[carousel] ✓ Slick détruit avec succès');
      }
    } catch(e) {
      console.log('[carousel] Impossible de détruire Slick :', e.message);
    }
  }
  
  var currentIndex = 0;


  // Réveiller les images lazy-loadées
// Réveiller les images lazy-loadées
function loadImage(slide) {
  if (!slide) return;
  
  var imgs = slide.querySelectorAll('img');
  
  imgs.forEach(img => {
    // L'URL peut être dans data-srcset (responsive) ou data-src
    var srcset = img.getAttribute('data-srcset');
    var src = img.getAttribute('data-src');
    
    // Si c'est un srcset, extraire la première URL (avant l'espace)
    if (srcset && !src) {
      src = srcset.split(' ')[0]; // Prendre la première URL
    }
    
    // Mettre l'URL dans src
    if (src) {
      img.src = src;
      img.removeAttribute('data-srcset'); // Retirer pour éviter les conflits
      img.classList.remove('lazyload');
      img.classList.add('lazyloaded');
      console.log('[carousel] ✓ Image chargée: ' + src.slice(-50));
    } else {
      console.log('[carousel] ✗ Image: aucune URL trouvée');
    }
  });
}
  
  // Fonction pour afficher un slide
  function showSlide(index) {
  if (index < 0 || index >= slides.length) return;
  
  
  
  // Afficher LE BON slide
  // Afficher LE BON slide
slides[index].classList.add('is-active');
slides[index].style.cssText = 'display: block !important; opacity: 1 !important; visibility: visible !important;';

// **IMPORTANT** : charger les images lazy-loadées
loadImage(slides[index]);

// Aussi pré-charger la suivante pour plus de fluidité
if (slides[index + 1]) loadImage(slides[index + 1]);
  
  // **DIAGNOSTIC** : vérifier l'état réel de l'image
  var img = slides[index].querySelector('img');
  var computed = window.getComputedStyle(slides[index]);
  console.log('[carousel] DIAG slide ' + (index + 1) + 
    ' | display:' + computed.display + 
    ' | opacity:' + computed.opacity + 
    ' | visibility:' + computed.visibility + 
    ' | z-index:' + computed.zIndex +
    ' | img.src:' + (img ? img.src.slice(-40) : 'AUCUNE IMG'));
  
  // Mettre à jour les vignettes
  thumbs.forEach((thumb, i) => {
    if (i === index) {
      thumb.classList.add('is-active');
    } else {
      thumb.classList.remove('is-active');
    }
  });
  
  currentIndex = index;
}
  // Navigation
  function nextSlide() {
    var next = (currentIndex + 1) % slides.length;
    showSlide(next);
  }
  
  function prevSlide() {
    var prev = (currentIndex - 1 + slides.length) % slides.length;
    showSlide(prev);
  }
  
  // Créer les flèches
  var wrapper = document.querySelector('.productView-image-wrapper');
  if (wrapper && !wrapper.querySelector('.carousel-arrows.prev')) {
    var prevBtn = document.createElement('button');
    prevBtn.className = 'carousel-arrows prev';
    prevBtn.innerHTML = '&#8249;';
    prevBtn.type = 'button';
    prevBtn.setAttribute('aria-label', 'Image précédente');
    prevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      prevSlide();
      console.log('[carousel] ✓ Clic flèche précédente');
    });
    wrapper.appendChild(prevBtn);
    
    var nextBtn = document.createElement('button');
    nextBtn.className = 'carousel-arrows next';
    nextBtn.innerHTML = '&#8250;';
    nextBtn.type = 'button';
    nextBtn.setAttribute('aria-label', 'Image suivante');
    nextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      nextSlide();
      console.log('[carousel] ✓ Clic flèche suivante');
    });
    wrapper.appendChild(nextBtn);
    
    console.log('[carousel] ✓ Flèches créées');
  }
  
  // Clics sur les vignettes
  thumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      showSlide(index);
      console.log('[carousel] ✓ Clic vignette ' + (index + 1));
    });
  });
  
  // Swipe sur mobile
  var touchStart = 0;
  var touchEnd = 0;
  
  nav.addEventListener('touchstart', e => {
    touchStart = e.changedTouches[0].screenX;
  }, { passive: true });
  
  nav.addEventListener('touchend', e => {
    touchEnd = e.changedTouches[0].screenX;
    if (Math.abs(touchStart - touchEnd) > 50) {
      if (touchStart > touchEnd) {
        nextSlide();
      } else {
        prevSlide();
      }
    }
  }, { passive: true });
  
  // Afficher le premier slide
  showSlide(0);
  console.log('[carousel] ✅ INIT OK avec ' + slides.length + ' slides - Carousel prêt !');
}

// Lancer le script
initCarousel().catch(error => {
  console.error('[carousel] ERREUR fatale:', error);
});

